export class PublicUrlsProvider {
    static StatusPageUrl = 'https://status.skykick.com';
    static SupportPageUrl = 'https://www.skykick.com/support/get-support#contact_us';
    static DevPortalPageUrl = 'https://developers.skykick.com';
    static TermsPageUrl = 'https://www.skykick.com/developer-terms-conditions';
    static SmCustomerSupportPageUrl = 'https://support.skykick.com/hc/en-us/articles/1500001761902';
}
